<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24">
                <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                <el-button type="success" size="small" icon="iconfont icon-daochu shuaxin" @click="exportExcel">导出Excel</el-button>
                <!--<el-button type="primary" size="small" icon="iconfont icon-jia shuaxin" @click="dialogFormVisible = true">新增</el-button>-->
                <!-- <el-button @click="delMultiple" type="danger" size="small" icon="iconfont icgion-shanchu shuaxin">删除</el-button> -->
            </el-col>

            <!-- search start  -->
            <el-col :span="24" class="search-content">
                <!-- <div class="search-item" style="width: 130px;">
                    <el-select v-model="data.searchSelect" placeholder="请选择titleSelect" size="small">
                        <el-option
                            v-for="item in [{id: 1, name: 'test_select'}]"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div> -->
                <div class="search-item">
                    <el-input v-model="data.id" type="number" size="small" placeholder="请输入会员ID" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-input v-model="data.nickname" size="small" placeholder="请输入会员昵称" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-input v-model="data.phone" type="number" size="small" placeholder="请输入会员电话" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
                </div>
            </el-col>
            <!-- search end  -->

            <el-col class="main-content">
                <el-table :data="dataList" border @selection-change="handleSelectionChange" v-loading="loading" style="width: 100%">
                    <!--<el-table-column type="selection" width="55"></el-table-column>-->
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>

                    <!--<el-table-column prop="pid" label="上级id" width="180"></el-table-column>-->
                    <el-table-column prop="nickname" label="昵称" width="150"></el-table-column>
                    <el-table-column prop="phone" label="电话号码" width="120"></el-table-column>
                    <el-table-column prop="head_portrait" label="头像" width="80">
                      <template slot-scope="scope" v-if="scope.row.head_portrait">
                        <el-popover
                          placement="right"
                          width="150"
                          trigger="click">
                          <el-image
                            style="width: 150px; height: 150px"
                            :src="scope.row.head_portrait">
                          </el-image>
                          <el-image
                            slot="reference"
                            style="width: 50px; height: 50px; cursor: pointer;"
                            :src="scope.row.head_portrait">
                          </el-image>
                        </el-popover>
                      </template>
                    </el-table-column>
                    <el-table-column prop="petrol_money" label="汽油卡余额" width="100"></el-table-column>
                    <el-table-column prop="diesel_money" label="柴油卡余额" width="100"></el-table-column>
                    <el-table-column prop="integral" label="积分" width="100"></el-table-column>
                    <el-table-column prop="commission" label="佣金" width="100"></el-table-column>
                    <el-table-column prop="sub_count" label="下级人数" width="90"></el-table-column>
                    <el-table-column prop="consume_oil_money" label="累计加油金额" width="110"></el-table-column>
                    <el-table-column prop="grade_data" label="会员等级" width="120">
                      <template slot-scope="scope">
                        <div>汽油：{{scope.row.grade_data.user_petrol_title}}</div>
                        <div>柴油：{{scope.row.grade_data.user_diesel_title}}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="qr_img" label="邀请二维码" width="100">
                      <template slot-scope="scope" v-if="scope.row.qr_img">
                        <el-popover
                          placement="right"
                          width="150"
                          trigger="click">
                          <el-image
                            style="width: 150px; height: 150px"
                            :src="scope.row.qr_img">
                          </el-image>
                          <el-image
                            slot="reference"
                            style="width: 50px; height: 50px; cursor: pointer;"
                            :src="scope.row.qr_img">
                          </el-image>
                        </el-popover>
                      </template>
                    </el-table-column>
                    <el-table-column prop="created_at" label="加入时间" width="180"></el-table-column>
                    <el-table-column label="操作" min-width="200">
                        <template slot-scope="scope">
                            <div>
                              <el-button @click="editTmp(scope.row)" icon="iconfont icon-bianji shuaxin" type="primary" size="mini" plain :disabled="!power.users_add">编辑</el-button>
                              <el-button @click="couponTmp(scope.row)" icon="iconfont iconyouhuiquan-copy shuaxin" type="primary" size="mini" plain :disabled="!power.users_coupon_number">赠优惠券</el-button>
                            </div>
                            <div style="padding-top: 5px;">
                              <el-button v-if="scope.row.status == 2" @click="setStatus(scope.row.id, 1)" icon="iconfont iconsuoding shuaxin" size="mini" type="danger" plain :disabled="!power.users_set_status">冻结</el-button>
                              <el-button v-if="scope.row.status == 1" @click="setStatus(scope.row.id, 2)" icon="iconfont iconsuoding shuaxin" size="mini" type="success" plain :disabled="!power.users_set_status">正常</el-button>
                              <el-button @click="prizeTmp(scope.row)" icon="iconfont iconchoujiang shuaxin" type="primary" size="mini" plain :disabled="!power.users_prize_number">赠抽奖号</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                    @current-change="changePage"
                    @size-change="changePageSize"
                    background
                    :layout="pageLayout"
                    :page-sizes="pagePageSizes"
                    :page-size="pagePageSize"
                    :total="totalCount"
                    :current-page.sync="current_page"
                    :hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>

        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" :close-on-click-modal="false" @close="dialogClose" width="550px" center>
            <el-form :model="form" ref="form" class="dialog-form" @submit.native.prevent>
                <el-form-item label="昵称"
                    :label-width="formLabelWidth"
                    prop="nickname"
                    :rules="[
                    { required: true, message: '请输入昵称', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.nickname" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="电话号码"
                    :label-width="formLabelWidth"
                    prop="phone"
                    :rules="[
                    { required: true, message: '请输入电话号码', trigger: 'blur' }
                    ]">
                    <el-input type="text" v-model="form.phone" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addData('form')">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="dialogTitlePrize" :visible.sync="dialogFormVisiblePrize" @close="dialogClosePrize" :close-on-click-modal="false" width="550px" center>
            <el-form :model="formPrize" ref="formPrize" class="dialog-form" @submit.native.prevent>
                <el-form-item label="赠送数量"
                    :label-width="formLabelWidth"
                    prop="num"
                    :rules="[
                    { required: true, message: '请输入赠送数量', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="formPrize.num" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisiblePrize = false">取 消</el-button>
                <el-button type="primary" @click="addPrizeNumber('formPrize')">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="dialogTitleCoupon" :visible.sync="dialogFormVisibleCoupon" @close="dialogCloseCoupon" :close-on-click-modal="false" width="550px" center>
            <el-form :model="formCoupon" ref="formCoupon" class="dialog-form" @submit.native.prevent>
                <el-form-item label="优惠券"
                    :label-width="formLabelWidth"
                    prop="coupon_id"
                    :rules="[
                    { required: true, message: '请选择优惠券', trigger: 'blur' }
                    ]">
                    <el-select v-model="formCoupon.coupon_id" placeholder="请选择优惠券">
                        <el-option
                            v-for="item in couponList"
                            :key="item.id"
                            :label="item.title"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="赠送数量"
                    :label-width="formLabelWidth"
                    prop="num"
                    :rules="[
                    { required: true, message: '请输入赠送数量', trigger: 'blur' }
                    ]">
                    <el-input type="number" v-model="formCoupon.num" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisibleCoupon = false">取 消</el-button>
                <el-button type="primary" @click="addCouponNumber('formCoupon')">确 定</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {UsersIndex, UsersAdd, UsersDel, UsersPrizeNumber, UsersCouponNumber, UsersSetStatus} from "@/utils/request.js"
    import {mapState} from "vuex"

    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize,
                    searchSelect: '',
                    id: '',
                    nickname: '',
                    phone: '',
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
                dialogFormVisible: false,
                dialogFormVisiblePrize: false,
                dialogFormVisibleCoupon: false,
                loadingAdd: false,
                loadingAddPrize: false,
                loadingAddCoupon: false,
                dialogTitle: "新增会员",
                dialogTitlePrize: "赠送抽奖号码",
                dialogTitleCoupon: "赠送优惠券",
                formLabelWidth: "120px",
                form: {
                    id: 0,
                    nickname: "",
                    phone: "",
                },
                formPrize: {
                    id: 0,
                    num: ""
                },
                formCoupon: {
                    id: 0,
                    num: 1,
                    coupon_id: ""
                },
                multipleSelection: [],
                couponList: []
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(["power", "loginInfo"]),
        methods: {
            search() {
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                UsersIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                        this.couponList = res.data.couponList
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
                this.data.page_size = size
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            addData(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAdd = true
                        UsersAdd(this.form).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogFormVisible = false
                                this.data.page--
                                this.getList()
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAdd = false
                        })
                    }
                });
            },
            addPrizeNumber(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAddPrize = true
                        UsersPrizeNumber(this.formPrize).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogFormVisiblePrize = false
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAddPrize = false
                        })
                    }
                });
            },
            addCouponNumber(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loadingAddCoupon = true
                        UsersCouponNumber(this.formCoupon).then((res) => {
                            if (res.code == 200) {
                                this.$message.success(res.msg);
                                this.dialogFormVisibleCoupon = false
                            } else {
                                this.$message.error(res.msg);
                            }
                            this.loadingAddCoupon = false
                        })
                    }
                });
            },
            editTmp(data) {
                this.form = {
                    id: data.id,
                    nickname: data.nickname,
                    phone: data.phone,
                }
                this.dialogTitle = this.form.id > 0 ? "编辑会员" : "新增会员"
                this.dialogFormVisible = true
            },
            prizeTmp(data) {
                this.formPrize = {
                    id: data.id,
                    num: ""
                }
                this.dialogTitlePrize = `赠送[${data.nickname}]抽奖号码`
                this.dialogFormVisiblePrize = true
            },
            couponTmp(data) {
                this.formCoupon.id = data.id
                this.dialogTitleCoupon = `赠送[${data.nickname}]优惠券`
                this.dialogFormVisibleCoupon = true
            },
            dialogClose() {
                this.initForm()
            },
            dialogClosePrize() {
              this.formPrize = {
                id: 0,
                num: ""
              }
              this.$refs["formPrize"].resetFields()
            },
            dialogCloseCoupon() {
              this.formCoupon = {
                id: 0,
                num: 1,
                coupon_id : ""
              }
              this.$refs["formCoupon"].resetFields()
            },
            initForm() {
                // 初始化，form数据
                this.form = {
                    id: 0,
                    nickname: "",
                    phone: "",
                }
                // 重置字段验证
                this.$refs["form"].resetFields();
                this.dialogTitle = "新增会员"
            },
            handleSelectionChange(val) {
                this.multipleSelection = []
                if (val.length > 0) {
                    val.filter((item) => {
                        this.multipleSelection.push(item.id)
                    })
                }
            },
            delMultiple() {
                if (this.multipleSelection.length == 0) {
                    this.$message.error("请至少选择一项你要删除的项");
                    return
                }
                this.del(this.multipleSelection)
            },
            del(id) {
                this.$confirm("确定要执行删除操作吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "error"
                }).then(() => {
                    UsersDel({id: id}).then((res) => {
                        if (res.code == 200) {
                            this.data.page--
                            this.getList()
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                    // 取消操作
                });
            },
            exportExcel(type) {
              this.$confirm("确定要导出列表数据吗?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "success"
              }).then(() => {
                  let url = '';
                  for(var k in this.data){
                    let value = this.data[k] !==undefined ? this.data[k] : '';
                    if (k == 'page') { continue }
                    url += `&${k}=${encodeURIComponent(value)}`
                  }
                  url += `&type=${type}`
                  location.href = this.loginInfo.app_url+'/manage/users/excel?' + url.substring(1)
              }).catch(() => {
                  // 取消操作
              });
            },
            setStatus(id, status) {
              let msg = ''
              if (status == 1) {
                msg = '确定要解冻此用户吗?'
              } else {
                msg = '确定要冻结此用户吗?'
              }
              this.$confirm(msg, "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
              }).then(() => {
                  UsersSetStatus({id: id, status: status}).then((res) => {
                      if (res.code == 200) {
                          this.data.page--
                          this.getList()
                          this.$message.success(res.msg);
                      } else {
                          this.$message.error(res.msg);
                      }
                  })
              }).catch(() => {
                  // 取消操作
              });
            }
        }
    }
</script>

<style>
</style>
